import { formatAuditFieldLabel, formatAuditValue } from '../../../../lib/auditFormatters';

import { describeSocialChange } from './audit-social';

const rowStyle = {
  fontSize: 10.5,
  color: 'var(--nb-muted)',
  marginTop: 3,
  // A long value wraps instead of widening the row, and with it the page.
  overflowWrap: 'anywhere',
} as const;

interface AuditFieldRowProps {
  field: string;
  change: { before: unknown; after: unknown };
}

/** One changed field. Social changes read as plain words per platform; the rest as before → after. */
export function AuditFieldRow({ field, change }: AuditFieldRowProps) {
  if (field === 'social') {
    return (
      <>
        {describeSocialChange(change.before, change.after).map((line) => (
          <div key={line} className="nb-mono" style={rowStyle}>
            {line}
          </div>
        ))}
      </>
    );
  }
  return (
    <div className="nb-mono" style={rowStyle}>
      <span style={{ color: 'var(--nb-ink-2)', fontWeight: 700 }}>
        {formatAuditFieldLabel(field)}
      </span>{' '}
      <span style={{ textDecoration: 'line-through' }}>{formatAuditValue(change.before)}</span> →{' '}
      <span style={{ color: 'var(--nb-ink)' }}>{formatAuditValue(change.after)}</span>
    </div>
  );
}
